import { lazy } from 'react';

/**
 * React.lazy wrapper that recovers from stale deploy ChunkLoadErrors
 * (old main.js referencing hashed chunks removed after a new deploy).
 * Reloads once per session, then rethrows if it still fails.
 */
export function lazyWithRetry(factory) {
  return lazy(async () => {
    const key = 'cai_chunk_reload';
    try {
      const mod = await factory();
      sessionStorage.removeItem(key);
      return mod;
    } catch (error) {
      const message = String(error?.message || error || '');
      const isChunkError =
        error?.name === 'ChunkLoadError' ||
        /Loading chunk [\d]+ failed/i.test(message) ||
        /Failed to fetch dynamically imported module/i.test(message);

      if (isChunkError && !sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, '1');
        window.location.reload();
        return new Promise(() => {});
      }

      sessionStorage.removeItem(key);
      throw error;
    }
  });
}
